module.exports = __webpack_public_path__ + "static/media/gps.72244350.svg";